import React from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'sonner'
import MapWrapper from '@/features/dashboard/components/maps/map-wrapper'
import QueryProvider from '@/shared/components/query-provider'
import { SessionProvider } from '@/features/auth/context/session.context'
import App from './App'
import '@/styles/globals.scss'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Failed to find the root element')
}

const root = createRoot(container)

root.render(
  <React.StrictMode>
    <Toaster position="top-center" />
    <MapWrapper>
      <QueryProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </QueryProvider>
    </MapWrapper>
  </React.StrictMode>
)

